import React from 'react';
import { Button, ButtonGroup, Row } from 'react-bootstrap';
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider';
import { SliderRail, Handle, Track, Tick } from '../../widgets/Slider';
import { DISPLAY_DATETIME_FORMAT2, DISPLAY_DATE_FORMAT2, DISPLAY_TIME_FORMAT2 } from '../../../constants';
import "../../../../assets/css/react-datetime.css";

export const toDisplayDate = momentDate => momentDate.format(DISPLAY_DATE_FORMAT2);

export const toDisplayTime = momentDate => momentDate.format(DISPLAY_TIME_FORMAT2);

export const toDisplayDateTime = momentDate => momentDate.format(DISPLAY_DATETIME_FORMAT2);

export const SpeedRange = ({ speed, onSelect }) => {
    const speeds = [1, 5, 10, 50, 100, 200, 500, -1];
    return <div className={`speed-range float-right`}>
        <ButtonGroup size="sm" toggle={true}>
            {speeds.map((n, i) =>
                <Button
                    key={i}
                    variant={(n === speed) ? "primary" : "default"}
                    size="sm"
                    onClick={event => onSelect(n, event)}>
                    {n === -1 ? 'Full' : `${n}x`}
                </Button>)}
        </ButtonGroup>
    </div>;
};

export const CloseButton = ({ onClick }) =>
    <div className="close-box">
        <i className={`fa fa-times`} onClick={onClick} title="Close" />
    </div>;

export const Loading = () =>
    <Row>
        <div className="loading">Loading....</div>
    </Row>;

export const ReplayKPIBox = (props) => {
    const { settings: { speedShortName } } = props;
    const { kpiData: { acres, loads, bales, avgSpeed, maxSpeed,
        isArea, isSpeed, isLoad, isBale } } = props;

    return (<div className="reply-kpi-box user-select-none">
        <div className={isArea ? '' : 'hide'}>
            <span>{acres}</span> <label>acres</label>
        </div>
        <div className={isLoad ? '' : 'hide'}>
            <span>{loads}</span> <label>loads</label>
        </div>
        <div className={isBale ? '' : 'hide'}>
            <span>{bales}</span> <label>bales</label>
        </div>
        <div className={isSpeed ? '' : 'hide'}>
            <span>{avgSpeed || 0} ({speedShortName})</span> <label>avg. speed</label>
        </div>
        <div className={isSpeed ? '' : 'hide'}>
            <span>{maxSpeed || 0} ({speedShortName})</span> <label>max. speed</label>
        </div>
    </div>)
};

export const RangeSlider = ({ step, domain, reversed, values, tickValues, formatTicks, onUpdate, onChange }) => {
    return (
        <Slider
            mode={2}
            step={step || 30}
            domain={domain}
            reversed={reversed}
            onUpdate={onUpdate}
            onChange={onChange}
            values={values}
            className="range-slider">
            <Rail>
                {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
            </Rail>
            <Handles>
                {({ handles, getHandleProps }) => (
                    <div className="slider-handles">
                        {handles.map(handle => (
                            <Handle
                                key={handle.id}
                                handle={handle}
                                domain={domain}
                                getHandleProps={getHandleProps}
                            />
                        ))}
                    </div>
                )}
            </Handles>
            <Tracks left={false} right={false}>
                {({ tracks, getTrackProps }) => (
                    <div className="slider-tracks">
                        {tracks.map(({ id, source, target }) => (
                            <Track
                                key={id}
                                source={source}
                                target={target}
                                getTrackProps={getTrackProps}
                            />
                        ))}
                    </div>
                )}
            </Tracks>
            <Ticks values={tickValues}>
                {({ ticks }) => (
                    <div className="slider-ticks">
                        {ticks.map((tick,i) => (
                            <Tick
                                key={tick.id}
                                format={formatTicks}
                                tick={tick}
                                count={ticks.length}
                                index={i}
                            />
                        ))}
                    </div>
                )}
            </Ticks>
        </Slider>
    )
}



export const SpeedRangeLabel = ({ speedvariation: s, settings }) => {

    if (!s || s.length === 0) return null;
    const { speedShortName } = settings;

    const maxThreshold = s.reduce((prev, current) => (prev.speed_variation_range > current.speed_variation_range) ? prev : current);
    const getThreshold = (s) => (s.speed_variation_range === maxThreshold.speed_variation_range) ?
        `>${s.minSpeed}` : `<=${s.maxSpeed}`;

    return (
        <div className="speed-variation-box">
            {s.map(e => (
                <div key={e.speed_variation_range} className="speed-variation-box__color-container">
                    <span className="speed-variation-box__color" style={{ background: e.color }}></span>
                    <span className="speed-variation-box__value">
                        {getThreshold(e)}
                        <sub className="speed-variation-unit">{speedShortName}</sub>
                    </span>
                </div>
            ))}
        </div>
    )
}